module.exports = __webpack_public_path__ + "static/media/Druddigon_gaussian2.ebff1913.png";